const isValidEmail = (email) => {
  if (!email) return true; // Email is optional
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/; // More restrictive
  return emailRegex.test(email);
};

export default isValidEmail;